"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INetAnnotationSchema = void 0;
const zod_1 = require("zod");
const NetAnnotationType_1 = require("./NetAnnotationType");
exports.INetAnnotationSchema = zod_1.default
    .object({
    net: zod_1.default.string(),
    type: NetAnnotationType_1.NetAnnotationTypeSchema,
})
    .passthrough();
//# sourceMappingURL=INetAnnotation.js.map